import { render, staticRenderFns } from "./PalmCube.vue?vue&type=template&id=4530218a&"
import script from "./PalmCube.vue?vue&type=script&lang=js&"
export * from "./PalmCube.vue?vue&type=script&lang=js&"
import style0 from "./PalmCube.vue?vue&type=style&index=0&id=4530218a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports